import { render, staticRenderFns } from "./messageviewhtml.vue?vue&type=template&id=3867af77&"
import script from "./messageviewhtml.vue?vue&type=script&lang=ts&"
export * from "./messageviewhtml.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/Rnwood.Smtp4dev/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3867af77')) {
      api.createRecord('3867af77', component.options)
    } else {
      api.reload('3867af77', component.options)
    }
    module.hot.accept("./messageviewhtml.vue?vue&type=template&id=3867af77&", function () {
      api.rerender('3867af77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messageviewhtml.vue"
export default component.exports